function pmt(rate, nper, pv, fv = 0) {
  const numerator = pv * rate * ((1 + rate) ** nper);
  const denominator = ((1 + rate) ** nper) - 1;
  return -(numerator / denominator + fv);
}

function convertFinancePrices(root) {
  const priceElements = root.getElementsByClassName("fin_price");
  for (let i = 0; i < priceElements.length; i++) {
    const el = priceElements[i];
    if (el.dataset.converted) continue;
    const priceInCents = parseInt(el.textContent, 10);
    if (isNaN(priceInCents)) continue;
    const price = priceInCents / 100;
    const payment = pmt(0.1274 / 12, 48, -price);
    el.textContent = `R${payment.toFixed(2)} pm`;
    el.dataset.converted = "true";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  convertFinancePrices(document);

  document.querySelectorAll("product-recommendations").forEach((recEl) => {
    new MutationObserver(() => convertFinancePrices(recEl)).observe(recEl, {
      childList: true,
      subtree: true,
    });
  });
});